module.exports = __webpack_public_path__ + "images/dog-icon.74a01d17.svg";